import _ from 'lodash';
import debug from '../debug';
import getProductContent from './get-product-content';

const filterProductScopedSections = (products, categorys, selectedsections) => {
    const ret = [];
    const productCategorys = getProductContent(products, categorys);
    _.each(selectedsections, (section) => {
        _.each(productCategorys, (category) => {
            if (category.items.find((x) => x.slug === section.slug)) {
                if (!ret.find((x) => x.slug === section.slug)) {
                    ret.push(section);
                }
            }
        });
    });
    debug('filterProductScopedSections', ret);
    return ret;
};

export default filterProductScopedSections;
